import { currentCompany } from '../../actionTypes';

const initialState = {
  loading: true,
  saving: false,
  success: false,
  error: false,
  list: [],
};

export default function ownerWorkingHoursQuestions(state = initialState, action) {
  switch (action.type) {
    case currentCompany.ownerWorkingHoursQuestions.get.start:
      return initialState;

    case currentCompany.ownerWorkingHoursQuestions.get.end:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
      };

    case currentCompany.ownerWorkingHoursQuestions.get.error:
      return {
        ...state,
        loading: false,
        error: true,
        list: [],
      };

    case currentCompany.ownerWorkingHoursQuestions.create.start:
      return {
        ...state,
        saving: true,
      };

    case currentCompany.ownerWorkingHoursQuestions.create.end:
      return {
        ...state,
        saving: false,
        success: true,
        list: action.payload.list,
      };

    case currentCompany.ownerWorkingHoursQuestions.create.error:
      return {
        ...state,
        saving: false,
        error: true,
      };

    default:
      return state;
  }
}
